
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Posting, Application } from "@/generated/graphql";

import PageHeadContainer from "@/components/page/PageHeadContainer.vue";
import PageHeadIcon from "@/components/page/PageHeadIcon.vue";
import LocationIcon from "@/components/icons/LocationIcon.vue";
import UserIcon from "@/components/icons/UserIcon.vue";
import TimerIcon from "@/components/icons/TimerIcon.vue";
import ClockIcon from "@/components/icons/ClockIcon.vue";
import ApplyButton from "@/components/jobboard/ApplyButton.vue";
import getLocationInfo from "@/helpers/locations/getLocationInfo";
import getFormattedDuration from "@/helpers/getFormattedDuration";
import RouteNames from "@/entities/RouteNames";
import ItemChip from "@/components/common/ItemChip.vue";
import { formatCurrency } from "@/utils";



@Component({
  components: {
    PageHeadContainer,
    PageHeadIcon,
    LocationIcon,
    TimerIcon,
    ClockIcon,
    UserIcon,
    ApplyButton,
    ItemChip
  },
})
export default class PostingHeader extends Vue {
  @Prop({ type: Object, required: true }) readonly posting!: Posting;
  @Prop({ type: String, required: true }) readonly currentUserId!: string;
  @Prop({ type: Boolean, required: false }) readonly isManager!: boolean;

  applicationExists = false;
  routes = RouteNames;

  get getBudet(): string {
    let budget = "n/a";
    const minrate =this.posting.min_rate;
    const maxrate = this.posting.max_rate;
    if (minrate != null) {
      const isDecimal = `${minrate}`.match(/\./g);
      budget = formatCurrency(minrate, { precision: isDecimal ? 2: 0 });
    }
    if (maxrate != null) {
      const isDecimal = `${maxrate}`.match(/\./g);
      budget += `- ${formatCurrency(maxrate, { precision: isDecimal ? 2: 0 })}`;
    }
    return budget;
  }

  get manager(): any {
    const user = this.posting.manager?.user;
    if (!user) {
      return;
    }

    return {
      name: `${user.given_name} ${user.family_name}`,
      id: this.posting.manager!.id,
      avatar: user.avatar,
    }
  }
  get managerRouteName(): string | undefined {
    return this.isManager
      ? undefined /* If the RouteName is undefined, the manager chip will be inactive */
      : this.routes.MANAGER_ABOUT;
  }
  // get buttonVariant(): string {
  //   if (!this.applicationExists || this.isApplicationCancelled) {
  //     return "primary";
  //   }
  //   return "secondary";
  // }
  get type(): string | undefined {
    return this.posting.employment_type || undefined;
  }
  get jobDuration(): string | undefined {
    return getFormattedDuration(this.posting.duration);
  }

  // get manager(): string | undefined {
  //   const user = this.posting.manager?.user;
  //   if (!user) return undefined;

  //   return `${user.given_name} ${user.family_name}`;
  // }

  get location(): string {
    return getLocationInfo(this.posting, true);
  }

  @Watch('application', { immediate: true })
  postingUpdated() {
    this.applicationExists = this.posting.applications[0]?.is_cancelled === false;
  }

  updateCrumb() {
    const breadcrubmData = document.querySelector(
      '.site_breadcumb_ul li:nth-child(3) > span'
    );
    if (breadcrubmData) {
      breadcrubmData.innerHTML = `${this.posting.job_title}`;
    }
  }
  @Watch('posting')
  crumbdata() {
    this.updateCrumb();
  }
  @Watch('$route', { immediate: true, deep: true })
  onUrlChange() {
    this.updateCrumb();
  }

  @Watch("applicationExists")
  applicationUpdated() {
    this.$emit("applicationUpdated");
  }

  get application(): Application | undefined {
    return this.posting?.applications[0];
  }

  get isApplicationCancelled(): boolean | undefined {
    return this.application?.is_cancelled!;
  }

  get applicationId(): string | undefined {
    return this.application?.id;
  }
}
